import client from "./axiosConfig";

export const getDays = (params) => {
    const config = {
        url: "/tracker/day/",
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const getDayById = (dayId) => {
    const config = {
        url: `/tracker/day/${dayId}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const updateDay = (dayId, values) => {
    const config = {
        url: `/tracker/day/${dayId}/`,
        method: "PATCH",
        data: values,
    };
    const response = client(config);
    return response;
}

export const downloadTask = (params) => {
  const config = {
    url: "/tracker/download/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};